// themes.js
export const themes = {
    default: {
      primary: '#057FDB',
      secondary: '#42b983',
      accent: '#ff007f',
      background: '#f5f5f5',
      userMsgBg: 'deepskyblue',
      assistantMsgBg: '#42b983',
      text: '#333333',
      border: '#e1e4e8'
    },
    dark: {
      primary: '#4FC3F7',
      secondary: '#81C784',
      accent: '#FF5252',
      background: '#263238',
      userMsgBg: '#0288D1',
      assistantMsgBg: '#388E3C',
      text: '#FFFFFF',
      border: '#37474F'
    },
    corporate: {
      primary: '#1565C0',
      secondary: '#455A64',
      accent: '#D32F2F',
      background: '#F5F5F5',
      userMsgBg: '#1976D2',
      assistantMsgBg: '#455A64',
      text: '#212121',
      border: '#BDBDBD'
    }
    // 可以继续添加更多主题
  };